import { useState, useEffect } from "react";
import { api, unitWord } from "../../lib/api";
import { Trophy, RefreshCw } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function AdminLeaders() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    const { data } = await api.get("/leaderboard/live");
    setData(data);
    setBusy(false);
  };
  useEffect(() => { load(); }, []);

  if (!data) return <div className="py-10 text-center text-sm text-slate-500">Computing live standings…</div>;
  const leaders = data.brackets.map((b) => ({ label: b.label, leader: b.entries[0] })).filter((x) => x.leader && x.leader.final_score > 0);

  return (
    <div className="max-w-3xl">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="font-display font-semibold text-[#1a1f36]">Mid-Campaign Prize — current bracket leaders</h3>
          <p className="text-sm text-slate-600">Live standings (not the published snapshot) — the property or floor leading each bracket right now.</p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button size="sm" variant="outline" onClick={load} disabled={busy} data-testid="leaders-refresh-btn">
            <RefreshCw className={`w-4 h-4 mr-1 ${busy ? "animate-spin" : ""}`} /> Refresh
          </Button>
        </div>
      </div>
      {leaders.length === 0 ? (
        <p className="text-sm text-slate-500 py-10 text-center border border-dashed border-slate-300 rounded-md" data-testid="leaders-empty">No approved points anywhere yet — leaders will appear as submissions are approved.</p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3" data-testid="leaders-grid">
          {leaders.map(({ label, leader }) => (
            <div key={label} className="border border-slate-200 bg-[#f8f9fc] rounded-md p-4 flex items-center gap-3" data-testid={`leader-card-${label.replace(/[^a-zA-Z]/g, "-")}`}>
              <Trophy className="w-6 h-6 text-[#c8102e] shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="text-[10px] uppercase tracking-wide text-slate-500">{label}</div>
                <div className="font-semibold text-[#1a1f36] truncate">{leader.name}</div>
                <div className="text-xs text-slate-500">{leader.raw_task_points} raw pts · {leader.task_per_capacity?.toFixed(3)} per {unitWord(leader.capacity_type)}</div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-display font-bold text-lg text-[#c8102e]">{leader.final_score.toFixed(1)}</div>
                <div className="text-[10px] uppercase text-slate-400">Final score</div>
              </div>
            </div>
          ))}
        </div>
      )}
      <p className="text-xs text-slate-400 mt-3">Computed {new Date(data.computed_at).toLocaleString()}</p>
    </div>
  );
}
